/**
 * O que a tela escreve sobre a ficha do cadastro (`R-01`, ADR-041). Só apresentação: quem
 * decide confere ou diverge, e por quê, é o servidor (`categoria_no_cadastro`).
 */
import type { DetalheDoTransito } from "../api/tipos";
import type { Significado } from "../componentes/tinta";

export type Ficha = NonNullable<DetalheDoTransito["veiculo"]>;

export const ROTULO_DA_TAG: Record<Ficha["status_tag"], string> = {
  ATIVA: "ativa",
  BLOQUEADA: "bloqueada",
  NENHUMA: "sem TAG",
};

/** "Fiat Cronos · prata" — só o que o cadastro tem. */
export function nomeDoVeiculo(v: Ficha): string {
  return (
    [[v.marca, v.modelo].filter(Boolean).join(" "), v.cor]
      .filter(Boolean)
      .join(" · ") || "sem marca e modelo no cadastro"
  );
}

export function tagDaFicha(v: Ficha): string {
  const tag = ROTULO_DA_TAG[v.status_tag];
  return v.operadora_tag && v.status_tag !== "NENHUMA"
    ? `${tag} (${v.operadora_tag})`
    : tag;
}

/**
 * A categoria escolhida contra a do cadastro. A escolha muda no formulário antes de o servidor
 * saber dela; a comparação aqui é só "é o mesmo número?", e a explicação do porquê vem do
 * servidor (`categoria_no_cadastro`).
 */
export function comparacaoComOCadastro(
  escolhida: number | null,
  cadastral: number | null | undefined,
): { texto: string; cor: Significado } | null {
  if (cadastral == null || escolhida == null) return null;
  return escolhida === cadastral
    ? { texto: "confere com o cadastro", cor: "verde" }
    : { texto: `cadastro diz ${cadastral}`, cor: "amarelo" };
}
